import { z } from 'zod'

export const LEGAL_STATEMENT_MAX_LENGTH = 1000
export const LEGAL_STATEMENTS_MAX = 20

// One declaration a signer ticks before signing a gym document. `id` is absent
// on a statement the gym has just added; the Worker assigns it.
export const legalStatementSchema = z.object({
  id: z.string().uuid().optional(),
  text: z
    .string()
    .trim()
    .min(1, 'A statement cannot be empty')
    .max(
      LEGAL_STATEMENT_MAX_LENGTH,
      `A statement is at most ${LEGAL_STATEMENT_MAX_LENGTH} characters`,
    ),
  required: z.boolean(),
})

export const legalStatementsSchema = z.object({
  statements: z
    .array(legalStatementSchema)
    .max(LEGAL_STATEMENTS_MAX, `A document has at most ${LEGAL_STATEMENTS_MAX} statements`),
})

export type LegalStatementInput = z.infer<typeof legalStatementSchema>
